namespace GeniuzPOS.InventoryReport {
    export namespace IcReport01_VService {
        export const baseUrl = 'InventoryReport/IcReport01_V';

        export declare function Create(request: Serenity.SaveRequest<IcReport01_VRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<IcReport01_VRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<IcReport01_VRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<IcReport01_VRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "InventoryReport/IcReport01_V/Create",
            Update = "InventoryReport/IcReport01_V/Update",
            Delete = "InventoryReport/IcReport01_V/Delete",
            Retrieve = "InventoryReport/IcReport01_V/Retrieve",
            List = "InventoryReport/IcReport01_V/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>IcReport01_VService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
